import { useTranslation } from 'react-i18next';
import { getDBAllUsersLeadersTableColumns } from '../../../data/formsAndTable/tables/dataTables/DataSource';
import AjaxSourcedData from '../../formsAndTable/tables/dataTables/dataSource/AjaxSourcedData';

import { Row, Col, Button, FormGroup, Label, Input } from 'reactstrap';
import React, { useEffect } from 'react';

import { NoDataComponent } from '../../formsAndTable/forms/formControls/NoDataComponent';
import { LeadersFilters } from './components/leadersFilters';

type LeadersTabContentProps = {
  tabItem: { id: number; title: string };
  statItems?: any;
  perPage: number;
  totalRows: number;
  setPage: (page: number) => void;
  setPerPage: (perPage: number) => void;
  setSort: (sort: 'asc' | 'desc') => void;
  setSortKey: (sortKey: string) => void;
  search: string;
  setSearch: (search: string) => void;
  handleModalOpen: (id: number) => void;
  handleHistoryOpen: (id: number) => void;
  filters?: {
    tabId: number;
    passedExams: string;
    passedEqualityKey: string;
    score: string;
    scoreEqualityKey: string;
    scoreQty: string;
    statusFilter: number[];
    passedExamsQty: string;
  };
  setFilters?: React.Dispatch<
    React.SetStateAction<{
      tabId: number;
      passedExams: string;
      passedEqualityKey: string;
      score: string;
      scoreEqualityKey: string;
      scoreQty: string;
      statusFilter: number[];
      passedExamsQty: string;
    }>
  >;
  statuses: { value: number; label: string; colorCode?: string }[];
  applyFilters?: () => void;
  conditions?: { value: string; label: string }[];
};

const LeadersTabContent = ({
  tabItem,
  statItems,
  perPage,
  totalRows,
  setPage,
  setPerPage,
  setSort,
  setSortKey,
  search,
  setSearch,
  handleModalOpen,
  handleHistoryOpen,
  filters,
  setFilters,
  statuses,
  applyFilters,
  conditions,
}: LeadersTabContentProps) => {
  const { t } = useTranslation();
  const [selectedPassedExam, setSelectedPassedExam] = React.useState<string>(
    filters && filters.tabId === tabItem.id ? filters.passedExams : (filters?.passedExams ?? 'all'),
  );

  useEffect(() => {
    if (filters && filters.tabId === tabItem.id && filters.passedExams !== selectedPassedExam) {
      setSelectedPassedExam(filters.passedExams);
    }
  }, [filters, selectedPassedExam, tabItem.id]);


  return (
    <>
      <Row>
        <Col sm="12" className="mt-4">
          {statItems && (
            <>
              <LeadersFilters
                setSelectedPassedExam={setSelectedPassedExam}
                setFilters={setFilters}
                tabItem={tabItem}
                selectedPassedExam={selectedPassedExam}
                filters={filters}
                applyFilters={applyFilters}
                statuses={statuses}
                conditions={conditions}
              />

              <AjaxSourcedData
                data={statItems}
                columns={getDBAllUsersLeadersTableColumns(t, handleModalOpen, handleHistoryOpen)}
                pagination={true}
                paginationServer={true}
                paginationPerPage={perPage}
                paginationDefaultPage={1}
                paginationTotalRows={totalRows}
                onChangePage={(p) => setPage(p)}
                onChangeRowsPerPage={(newPerPage, p) => {
                  setPerPage(newPerPage);
                  setPage(1);
                }}
                sortServer
                onSort={(column, direction) => {
                  const key = (column as any).sortField ?? (column as any).selector;
                  setSort(direction);
                  setSortKey(key);
                }}
                defaultSortAsc={false}
                searchServer
                searchText={search}
                onSearch={(value) => {
                  setSearch(value);
                  setPage(1);
                }}
                paginationRowsPerPageOptions={[20, 50, 100]}
                noDataComponent={<NoDataComponent />}
              />
            </>
          )}
        </Col>
      </Row>
    </>
  );
};

export default LeadersTabContent;
